import React, { useEffect, useState, Fragment, useRef } from "react";
import { base_url } from "../Api/Api";
import Skeletoncnt from "../Education/skeletonContent";
import Button from "@material-ui/core/Button";
import Comments from "../Common/Comments/Comments";

const Innernews = (props) => {
  const [status, setStatus] = useState({
    numPages: null,
    pageNumber: 1,
    pdfUrl: "",
  });
  const [state, setState] = useState({
    data: [], // data news
    statusNews: false, // loader status
    comments: [],
    statusComment: true,
  });
  useEffect(() => {
    setState({
      ...state,
      data: [],
    });
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    base_url
      .get(`news/${props.match.params.id}`)
      .then((response) => {
        base_url
          .get(`item_comment/${props.match.params.id}`, {

          })
          .then((responseComment) => {
            setState({
              ...state,
              data: response.data,
              statusNews: response.data.url.length === 0,
            });
            setTimeout(() => {
              let tags = document.getElementsByTagName("a");
              let tagsArry = Object.values(tags);
              let el = null;
              tagsArry.map((item) =>
                item.href.indexOf(".pdf") >= 1 ? (el = item) : null
              );
              if (el !== null) {
                el.addEventListener("click", (e) => displayDate(e, el.href));
              }
            }, 2000);
          })
          .catch((error) => {
            if (error.response != undefined) {
              setState({
                ...state,
                data: response.data,
                statusNews: response.data.url.length == 0,
              });
              if (error.response.status == 401) {
                props.history.push(`/Entrance`);
                localStorage.clear();
                window.location.reload();
              }
            }
          });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
            localStorage.clear();
            window.location.reload();
          }
        }
      });
  }, [props.match.params.id]);

  const displayDate = (e, url) => {
    e.preventDefault();
    setStatus({
      ...status,
      pdfUrl: url,
    });
  };

  return (
    <div className="inner-news news-web">
      <div className="contain">
        {/* <div style={{ width: 600 }}>
                <iframe src="https://s-plus.ir/storage/files/shares/samsung-galaxy-a11-a115u-en-um-tn-te5-final-web-06092020.pdf" />
                    <Document
                        file={"./test.pdf"}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={console.error}
                    >
                    </Document>
                </div> */}

        <div className="web-view">
          {state.data.length == 0 ? (
            state.statusNews ? (
              <span className="no-content">اطلاعاتی وجود ندارد</span>
            ) : (
              <Skeletoncnt />
            )
          ) : (
            <Fragment>
              <div className="detailes">
                <h4>{state.data.page_title}</h4>
                {state.data.comment_status ? (
                  <a href="#htmlCode">
                    <Button variant="contained">نظرات</Button>
                  </a>
                ) : null}
              </div>
              <div
                className="html-tag"
                dangerouslySetInnerHTML={{ __html: state.data.page_source }}
              ></div>
              <div className="tags all-styless bk-white">
                {state.data.tags.length == 0
                  ? null
                  : state.data.tags.map((info) => <span>{info.name}</span>)}
              </div>
            </Fragment>
          )}
          <div id="htmlCode" className="tab-comments">
            <Comments
              id={
                props.match.params.id.length !== 0
                  ? props.match.params.id
                  : null
              }
              data={state.data}
              cmntPlaceholder="فعلا نظری برای این خبر ثبت نشده است"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Innernews;
